import styled, { css } from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';

interface Props {
  checked?: boolean;
  colorActive: string;
  disabled?: boolean;
}

export const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  & input:checked ~ i {
    border: ${(props: Props) => `2px solid ${props.colorActive}`};
  }
  & input:checked ~ i:after {
    display: block;
    background: ${(props: Props) => props.colorActive};
  }
  & input:checked ~ i svg {
    display: block;
  }

  ${(props: Props) => props.checked && css`
    & input ~ i {
      border: ${(props: Props) => `2px solid ${props.colorActive}`};
    }
    & input ~ i:after {
      display: block;
      background: ${(props: Props) => props.colorActive};
    }
    & input ~ i svg {
      display: block;
    }
  `};

  ${(props: Props) => props.disabled && css`
    pointer-events: none;
    user-select: none;
    cursor: not-allowed;
    opacity: 0.7;
  `}
`;

export const Hidden = styled.input`
  position: absolute;
  opacity: 0;
  display: none;
  padding: 0;
  margin: 0;
`;

export const Mask = styled.i`
  display: flex;
  flex: 0 0 auto;
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  border: 2px solid ${COLORS.GRAY_TEXT};
  &:after {
    content: '';
    width: 12px;
    height: 12px;
    background: #757575;
    border-radius: 100%;
    margin: auto;
    display: none;
  }
`;

export const Text = styled.p`
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLACK};
  font-size: 14px;
  margin-left: 6px;
`;

export const MaskCheckbox = styled.i`
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  border: 2px solid ${COLORS.GRAY_TEXT};
  display: inline-flex;
  svg {
    position: absolute;
    display: none;
  }
`;